module.exports = __webpack_public_path__ + "img/quan-jia-icon.c5bd462b.png";